import React, { Component } from "react";
import "./Footer.css";
import githubLogo from "../assets/GitHub-Mark-Light-32px.png";

class Footer extends Component {
  render() {
    return (
      <footer className="inline">
        <h3>I made this! </h3>
        <a
          href="https://github.com/Brymastr/wedding"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={githubLogo} alt="github logo" />
        </a>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js